// IntersectionObserver のインスタンスを作成
let observer = new IntersectionObserver((entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) { // 要素がビューポート内に入ったとき
      let element = entry.target;
      element.src = element.dataset.src; // data-src から実際の src を設定
      observer.unobserve(element); // 一度読み込んだら監視を終了する
    }
  });
}, {
  rootMargin: '200px' // ビューポートから200px手前で読み込み開始
});

// 監視したいimgとiframeを選択
let lazyElements = document.querySelectorAll('img[data-src], iframe[data-src]');

// すべてのimgとiframeを監視
lazyElements.forEach(element => {
  if (!element.closest('[x-data]')) {
    observer.observe(element); // 表示されている要素だけを監視
  }
});

// x-data を持つ要素内の img と iframe の遅延読み込み用の IntersectionObserver を作成
let observerForXData = new IntersectionObserver((entries, observerForXData) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) { // x-data を持つ要素がビューポート内に入ったとき
      let parentElement = entry.target;
      let lazyElementsInXData = parentElement.querySelectorAll('img[data-src], iframe[data-src]'); // 子要素の img と iframe を取得

      // 親要素がビューポート内に入ったら、その中の img と iframe を読み込み
      lazyElementsInXData.forEach(element => {
        element.src = element.dataset.src; // data-src から実際の src を設定
      });

      observerForXData.unobserve(parentElement); // 一度監視を終了する
    }
  });
}, {
  rootMargin: '200px' // ビューポートから200px手前で読み込み開始
});

// 監視したい x-data を持つ要素を選択
let parentElementsWithXData = document.querySelectorAll('[x-data]');

// x-data を持つ要素を監視
parentElementsWithXData.forEach(parentElement => {
  observerForXData.observe(parentElement); // x-data を持つ要素を監視対象として登録
});
